import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FacilityComponent } from './facility/facility.component';
import { FacilityContactsComponent } from './facility/facility-contacts/facility-contacts.component';
import { FacilityLocationsComponent } from './facility/facility-locations/facility-locations.component';
import { FacilityRolesComponent } from './facility/facility-roles/facility-roles.component';
import { FacilityInventoryComponent } from './facility/facility-inventory/facility-inventory.component';
import { FacilityInventoryItemsComponent } from './facility/facility-inventory-items/facility-inventory-items.component';
import { FacilityInventoryItemDetailComponent } from './facility/facility-inventory-item-detail/facility-inventory-item-detail.component';
import { ReceiveInventoryComponent } from './facility/receive-inventory/receive-inventory.component';
import { PhysicalInventoryComponent } from './facility/physical-inventory/physical-inventory.component';
import { InventoryTransfersComponent } from './facility/inventory-transfers/inventory-transfers.component';
import { ReceiveReturnComponent } from './facility/receive-return/receive-return.component';
import { PickingComponent } from './facility/picking/picking.component';
import { StockMovesComponent } from './facility/stock-moves/stock-moves.component';
import { ManagePicklistsComponent } from './facility/manage-picklists/manage-picklists.component';
import { VerifyPicksComponent } from './facility/verify-picks/verify-picks.component';
import { PackingComponent } from './facility/packing/packing.component';
import { SchedulingComponent } from './facility/scheduling/scheduling.component';
import { IncomingShipmentsComponent } from './facility/incoming-shipments/incoming-shipments.component';
import { OutgoingShipmentsComponent } from './facility/outgoing-shipments/outgoing-shipments.component';
import { FacilityContentComponent } from './facility/facility-content/facility-content.component';
import { FacilityGeoLocationComponent } from './facility/facility-geo-location/facility-geo-location.component';
import { FacilityAgreementsComponent } from './facility/facility-agreements/facility-agreements.component';
import { ShippingGatewayConfigComponent } from './shipping-gateway-config/shipping-gateway-config.component';
import { ShipmentsComponent } from './shipments/shipments.component';
import { FacilitiesRoutingModule } from './facilities-routing.module';
import { UbsViewContainersModule } from '@urbannex/view-containers';
import { FacilityOverviewComponent } from './facility/facility-overview/facility-overview.component';
import { OverviewDetailComponent } from './facility/facility-overview/overview-detail/overview-detail.component';
import { OverviewContactsComponent } from './facility/facility-overview/overview-contacts/overview-contacts.component';
import { OverviewRolesComponent } from './facility/facility-overview/overview-roles/overview-roles.component';
import { FacilityPostalAddressComponent } from './facility/facility-overview/overview-contacts/facility-postal-address/facility-postal-address.component';
import { FacilityEmailAddressComponent } from './facility/facility-overview/overview-contacts/facility-email-address/facility-email-address.component';
import { FacilityTelecomNumbersComponent } from './facility/facility-overview/overview-contacts/facility-telecom-numbers/facility-telecom-numbers.component';



@NgModule({
  declarations: [
    FacilityComponent,
    FacilityContactsComponent,
    FacilityLocationsComponent,
    FacilityRolesComponent,
    FacilityInventoryComponent,
    FacilityInventoryItemsComponent,
    FacilityInventoryItemDetailComponent,
    ReceiveInventoryComponent,
    PhysicalInventoryComponent,
    InventoryTransfersComponent,
    ReceiveReturnComponent,
    PickingComponent,
    StockMovesComponent,
    ManagePicklistsComponent,
    VerifyPicksComponent,
    PackingComponent,
    SchedulingComponent,
    IncomingShipmentsComponent,
    OutgoingShipmentsComponent,
    FacilityContentComponent,
    FacilityGeoLocationComponent,
    FacilityAgreementsComponent,
    ShippingGatewayConfigComponent,
    ShipmentsComponent,
    FacilityOverviewComponent,
    OverviewDetailComponent,
    OverviewContactsComponent,
    OverviewRolesComponent,
    FacilityPostalAddressComponent,
    FacilityEmailAddressComponent,
    FacilityTelecomNumbersComponent
  ],
  imports: [
    CommonModule,
    FacilitiesRoutingModule,
    UbsViewContainersModule,
  ]
})
export class FacilitiesModule { }
